module.exports = __webpack_public_path__ + "img/icon_stars.5fcba9a.svg";